(() => {
  const MIN_TOTAL_CENTS = 1500; // 15,00 €

  async function updateMissing() {
    const el = document.getElementById("min-order-missing");
    if (!el) return;

    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      const missing = Math.max(0, MIN_TOTAL_CENTS - (cart.total_price || 0));
      // Geld formatieren (DE)
      const formatted = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: cart.currency || "EUR",
      }).format(missing / 100);

      el.textContent = formatted;

      // Optional: Wenn erreicht, Hinweis ausblenden
      const box = document.getElementById("min-order-hint");
      if (box) box.style.display = missing > 0 ? "" : "none";
    } catch (e) {
      // still fail silently
    }
  }

  // 1) initial
  document.addEventListener("DOMContentLoaded", () => {
    updateMissing();
    setTimeout(updateMissing, 300);
  });

  // 2) bei Klicks (plus/minus/remove)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("button, a");
    if (!btn) return;

    // typische cart controls (Theme-abhängig)
    if (
      btn.name === "plus" ||
      btn.name === "minus" ||
      btn.matches('[aria-label*="+"]') ||
      btn.matches('[aria-label*="-"]') ||
      btn.closest("cart-items") ||
      btn.closest(".cart__items")
    ) {
      setTimeout(updateMissing, 600);
      setTimeout(updateMissing, 1200);
    }
  });

  // 3) bei Input-Änderung (Mengenfeld)
  document.addEventListener("change", (e) => {
    if (e.target && (e.target.name === "updates[]" || e.target.closest("cart-items"))) {
      setTimeout(updateMissing, 600);
      setTimeout(updateMissing, 1200);
    }
  });
})();

function updateShippingEstimate(cartTotalCents) {
  const el = document.getElementById("shipping-value");
  if (!el) return;

  const FREE_SHIPPING_FROM = 3900;   // 39,00 € in Cent
  const MIN_ORDER = 1500;            // 15,00 € in Cent
  const SHIPPING_CENTS = 490;         // 4,90 € in Cent

  if (cartTotalCents < MIN_ORDER) {
    el.textContent = "–";
  } else if (cartTotalCents < FREE_SHIPPING_FROM) {
    el.textContent = "4,90 €";
  } else {
    el.textContent = "Kostenlos";
  }
}
updateShippingEstimate(cart.total_price);

